import { render, staticRenderFns } from "./task-add-or-update-purchase.vue?vue&type=template&id=85ded87c&scoped=true"
import script from "./task-add-or-update-purchase.vue?vue&type=script&lang=js"
export * from "./task-add-or-update-purchase.vue?vue&type=script&lang=js"
import style0 from "./task-add-or-update-purchase.vue?vue&type=style&index=0&id=85ded87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ded87c",
  null
  
)

export default component.exports